import { useEffect, useState } from "react";
import { getUserInfo } from "../../apis/General/users";
import "../../styles/UserDashboard/Search.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Notifications from "../shared/Notifications";
import Logo from "../../images/closecarbon_logo_1-removebg-preview 1.png";
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  equalTo,
  query,
  update,
} from "firebase/database";

const pages = [
  {
    name: "dashboard",
    alias: "home",
  },
  {
    name: "verification",
    alias: "verify",
  },
  {
    name: "CCRT",
  },
  {
    name: "iot devices",
  },
  {
    name: "settings",
    alias: "scenario project"
  },
  {
    name: "resources",
    alias: "help"
  },
];

const Search = () => {
  const auth = useSelector((state) => state.auth);
  const { pathname } = useLocation();
  // console.log('auth', auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(true);
  const [kycStatus, setKycStatus] = useState("");
  const [word, setWord] = useState("");
  const [listOfNames, setListOfNames] = useState(
    pages.map((item) => item?.name)
  );
  const db = getDatabase();
  const tableRef = ref(db, "kycStatus");
  const [publicKey, setPublicKey] = useState(null);
  const [notifications1, setStaticNotifications] = useState([]);
  const [notifications2, setFirebaseNotifications] = useState([]);
  const tableRef1 = ref(db, "events");
  const tableRef2 = ref(db, "notifications");


  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const handleSearchModalOpen = () => setSearchModalOpen(true);
  const handleSearchModalClose = (e) => {
    if (e.target.classList.contains("search-list-modal")) {
      setSearchModalOpen(false);
    }
  }

  const fetchUserInfo = async () => {
    const response = await getUserInfo(auth?.userInfo?.id, auth?.token);
    console.log('getUserInfo', response);
    setFirstName(response?.data?.message?.firstName);
    setLastName(response?.data?.message?.lastName);
  };

  // console.log('mice', localStorage.getItem('kycCompleted') === "complete");

  useEffect(() => {
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (word.trim() === "") {
      setListOfNames(pages.map((item) => item?.name));
    } else {
      const temp = pages.filter(
        (page) => page?.name?.includes(word) || page?.alias?.includes(word)
      );
      setListOfNames(temp.map((item) => item?.name));
    }
  }, [word]);

  useEffect(() => {
    const kycLocalStorageStatus = localStorage.getItem("kycCompleted");
    // console.log('kycLocalStorageStatus', kycLocalStorageStatus, kycLocalStorageStatus !== "complete" );
    // console.log('kycStatus', kycStatus);
    if (kycStatus === "completed" && kycLocalStorageStatus !== "complete") {
      // console.log('finn');
      setTimeout(() => {
        setKycStatus("shown");
        localStorage.setItem("kycCompleted", "complete");
      }, 5000);
    }
  }, [kycStatus]);

  useEffect(() => {
    setSearchModalOpen(false)
  }, [pathname]);


  const handleGetKycUserStatus = () => {
    const eventsQuery = query(
      tableRef,
      orderByChild("user"),
      equalTo(auth?.userInfo?.id)
      // equalTo(response?.data?.message?.publicKey)
    );
    return onValue(eventsQuery, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const valueData = Object.values(data);
        if (localStorage.getItem("kycCompleted") !== "complete") {
          setKycStatus(valueData[0]?.status);
        }
        // const valueKeys = Object.keys(data);
        // setFirebaseStaticNotifications(valueData);

        // const prevNotifications = notifications;
        // prevNotifications.push(...filteredData);
        // setFirebaseNotifications(valueData);
      } else {
        console.log(`No firebase notifications found for this user`);
      }
    });
  };

  useEffect(() => {
    handleGetKycUserStatus();
  }, []);

  const handeMobileMenuOpen = () => {
    console.log("hello");
    dispatch({
      type: "SET_MENU_VISIBLE",
      payload: true,
    });
  };

  const getFirebaseNotifications = () => {
    // console.log("holla");
    const eventsQuery = query(
      tableRef2,
      orderByChild("user"),
      equalTo(auth?.userInfo?.id)
      // equalTo(response?.data?.message?.publicKey)
    );
    return onValue(eventsQuery, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const valueData = Object.values(data);
        console.log('valueData2', valueData);
        const filteredData = valueData?.filter((data) => data?.read === false);
        setFirebaseNotifications(filteredData);
      } else {
        console.log(`No firebase notifications found for this user`);
      }
    });
  };
  const getEventNotifications = () => {
    // console.log("holla");
    const eventsQuery = query(
      tableRef1,
      orderByChild("addressToRecord"),
      equalTo(publicKey)
      // equalTo(response?.data?.message?.publicKey)
    );
    return onValue(eventsQuery, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        const valueData = Object.values(data);
        const filteredData = valueData.filter(
          (item) => item.type === "Carbon Credits Transferred" || item.type === "Perform KYC"
          );
          console.log('valueData10', filteredData);
        const filteredFilteredData = filteredData?.filter((data) => data?.read === false)
        setStaticNotifications(filteredFilteredData);
      } else {
        console.log(`No carbon credit data found for this user`);
      }
    });
  };

  useEffect(() => {
    getEventNotifications();
    getFirebaseNotifications();
  }, [publicKey]);

  console.log('notifications1', notifications1);
  console.log('notifications2', notifications2);

  return (
    <div className="search_container">
      <div>
        <div className="mobile_menu">
          <svg
            onClick={handeMobileMenuOpen}
            width="18"
            height="10"
            viewBox="0 0 18 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1H17"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M1 5H17"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M1 9H17"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>

          <img
            src={Logo}
            alt=""
            className="logo pointer"
            onClick={() => navigate("/dashboard")}
          />
        </div>
        <form className="search_form">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.77 18.3C9.2807 18.3 7.82485 17.8584 6.58655 17.031C5.34825 16.2036 4.38311 15.0275 3.81318 13.6516C3.24325 12.2757 3.09413 10.7616 3.38468 9.30096C3.67523 7.84029 4.39239 6.49857 5.44548 5.44548C6.49857 4.39239 7.84029 3.67523 9.30096 3.38468C10.7616 3.09413 12.2757 3.24325 13.6516 3.81318C15.0275 4.38311 16.2036 5.34825 17.031 6.58655C17.8584 7.82485 18.3 9.2807 18.3 10.77C18.3 11.7588 18.1052 12.738 17.7268 13.6516C17.3484 14.5652 16.7937 15.3953 16.0945 16.0945C15.3953 16.7937 14.5652 17.3484 13.6516 17.7268C12.738 18.1052 11.7588 18.3 10.77 18.3ZM10.77 4.74999C9.58331 4.74999 8.42327 5.10189 7.43657 5.76118C6.44988 6.42046 5.68084 7.35754 5.22672 8.45389C4.77259 9.55025 4.65377 10.7566 4.88528 11.9205C5.11679 13.0844 5.68824 14.1535 6.52735 14.9926C7.36647 15.8317 8.43556 16.4032 9.59945 16.6347C10.7633 16.8662 11.9697 16.7474 13.0661 16.2933C14.1624 15.8391 15.0995 15.0701 15.7588 14.0834C16.4181 13.0967 16.77 11.9367 16.77 10.75C16.77 9.15869 16.1379 7.63257 15.0126 6.50735C13.8874 5.38213 12.3613 4.74999 10.77 4.74999Z"
              fill="#667185"
            />
            <path
              d="M20 20.75C19.9014 20.7504 19.8038 20.7312 19.7128 20.6934C19.6218 20.6557 19.5392 20.6001 19.47 20.53L15.34 16.4C15.2075 16.2578 15.1354 16.0697 15.1388 15.8754C15.1422 15.6811 15.2209 15.4958 15.3583 15.3583C15.4958 15.2209 15.6811 15.1422 15.8754 15.1388C16.0697 15.1354 16.2578 15.2075 16.4 15.34L20.53 19.47C20.6704 19.6106 20.7493 19.8012 20.7493 20C20.7493 20.1987 20.6704 20.3893 20.53 20.53C20.4607 20.6001 20.3782 20.6557 20.2872 20.6934C20.1961 20.7312 20.0985 20.7504 20 20.75Z"
              fill="#667185"
            />
          </svg>

          <input
            className="search_input"
            type="text"
            placeholder="Search"
            name={word}
            onClick={() => {
              if(!searchModalOpen) {
                handleSearchModalOpen();
              }
            }}
            onChange={(e) => setWord(e.target.value)}
          />
          {searchModalOpen && 
         
            <div className="search-list">
            {listOfNames.includes("dashboard") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/dashboard");
                window.scrollTo(0, 0);
              }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.459 1.66059C12.3259 1.55684 12.162 1.50049 11.9932 1.50049C11.8245 1.50049 11.6606 1.55684 11.5275 1.66059L0.75 10.0643L1.68225 11.2433L3 10.2158V19.5001C3.00079 19.8977 3.15908 20.2787 3.44022 20.5599C3.72135 20.841 4.10242 20.9993 4.5 21.0001H19.5C19.8976 20.9993 20.2787 20.841 20.5598 20.5599C20.8409 20.2787 20.9992 19.8977 21 19.5001V10.2226L22.3177 11.2501L23.25 10.0711L12.459 1.66059ZM13.5 19.5001H10.5V13.5001H13.5V19.5001ZM15 19.5001V13.5001C14.9996 13.1024 14.8414 12.7211 14.5602 12.4399C14.279 12.1587 13.8977 12.0005 13.5 12.0001H10.5C10.1023 12.0005 9.721 12.1587 9.43978 12.4399C9.15856 12.7211 9.0004 13.1024 9 13.5001V19.5001H4.5V9.04659L12 3.20409L19.5 9.05409V19.5001H15Z"
                    fill="#667185"
                  />
                </svg>

                <div>Dashboard</div>
              </div>
            )}
          
            {listOfNames.includes("verification") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/verification");
                window.scrollTo(0, 0);
              }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M18 21H22.5V22.5H18V21Z" fill="#667185" />
                  <path
                    d="M15.75 22.5C16.1642 22.5 16.5 22.1642 16.5 21.75C16.5 21.3358 16.1642 21 15.75 21C15.3358 21 15 21.3358 15 21.75C15 22.1642 15.3358 22.5 15.75 22.5Z"
                    fill="#667185"
                  />
                  <path
                    d="M21.75 19.5C22.1642 19.5 22.5 19.1642 22.5 18.75C22.5 18.3358 22.1642 18 21.75 18C21.3358 18 21 18.3358 21 18.75C21 19.1642 21.3358 19.5 21.75 19.5Z"
                    fill="#667185"
                  />
                  <path
                    d="M19.5 19.5H15V18H19.5V19.5ZM18 15H22.5V16.5H18V15Z"
                    fill="#667185"
                  />
                  <path
                    d="M15.75 16.5C16.1642 16.5 16.5 16.1642 16.5 15.75C16.5 15.3358 16.1642 15 15.75 15C15.3358 15 15 15.3358 15 15.75C15 16.1642 15.3358 16.5 15.75 16.5Z"
                    fill="#667185"
                  />
                  <path
                    d="M16.1198 10.5974L9.74475 6.98615C9.63199 6.92226 9.5046 6.88867 9.375 6.88867C9.2454 6.88867 9.11801 6.92226 9.00525 6.98615L2.63025 10.5974C2.51482 10.6628 2.41881 10.7577 2.352 10.8723C2.2852 10.9869 2.25 11.1172 2.25 11.2499V18.7499C2.25 18.8826 2.2852 19.0129 2.352 19.1275C2.41881 19.2421 2.51482 19.337 2.63025 19.4024L9.00525 23.0136L9.74475 21.7087L3.75 18.3126V11.6872L9.375 8.50115L15 11.6872V13.4999H16.5V11.2499C16.5 11.1172 16.4648 10.9869 16.398 10.8723C16.3312 10.7577 16.2352 10.6628 16.1198 10.5974Z"
                    fill="#667185"
                  />
                  <path
                    d="M18.7501 11.2499H20.2501V5.2499C20.2501 5.11723 20.2149 4.98693 20.1481 4.8723C20.0813 4.75767 19.9853 4.66281 19.8699 4.5974L13.4949 0.98615C13.3821 0.922256 13.2547 0.888672 13.1251 0.888672C12.9955 0.888672 12.8681 0.922256 12.7554 0.98615L6.38037 4.5974L7.11987 5.9024L13.1251 2.5004L18.7501 5.68715V11.2499Z"
                    fill="#667185"
                  />
                </svg>

                <div>Verification</div>
              </div>
            )}
            {listOfNames.includes("CCRT") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/carbon-credit");
                window.scrollTo(0, 0);
              }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.1318 13.2668L17.6318 10.6043C17.5162 10.5358 17.3843 10.4997 17.2499 10.4999C17.1155 10.5 16.9837 10.5363 16.8682 10.605L12.3682 13.2675C12.2561 13.3337 12.1631 13.428 12.0985 13.5411C12.0339 13.6543 12 13.7823 12 13.9125V19.0875C12 19.353 12.1402 19.5983 12.3682 19.7325L16.8682 22.395C16.9836 22.4643 17.1155 22.5008 17.25 22.5008C17.3845 22.5008 17.5164 22.4643 17.6318 22.395L22.1318 19.7325C22.2439 19.6664 22.3369 19.5721 22.4015 19.4589C22.4661 19.3458 22.5 19.2178 22.5 19.0875V13.9125C22.5 13.7822 22.4661 13.6541 22.4015 13.5408C22.3369 13.4276 22.244 13.3331 22.1318 13.2668ZM21 18.66L17.25 20.8785L13.5 18.66V14.34L17.25 12.1215L21 14.34V18.66Z"
                    fill="#667185"
                  />
                  <path
                    d="M4.5 5.25C4.91421 5.25 5.25 4.91421 5.25 4.5C5.25 4.08579 4.91421 3.75 4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5C3.75 4.91421 4.08579 5.25 4.5 5.25Z"
                    fill="#667185"
                  />
                  <path
                    d="M6.75 5.25C7.16421 5.25 7.5 4.91421 7.5 4.5C7.5 4.08579 7.16421 3.75 6.75 3.75C6.33579 3.75 6 4.08579 6 4.5C6 4.91421 6.33579 5.25 6.75 5.25Z"
                    fill="#667185"
                  />
                  <path
                    d="M21 1.5H3C2.17275 1.5 1.5 2.17275 1.5 3V18C1.5 18.8272 2.17275 19.5 3 19.5H9.75V18H3V7.5H21V10.5H22.5V3C22.5 2.17275 21.8272 1.5 21 1.5ZM3 6V3H21V6H3Z"
                    fill="#667185"
                  />
                </svg>

                <div>CCRT</div>
              </div>
            )}

            {listOfNames.includes("iot devices") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/iot");
                window.scrollTo(0, 0);
              }}
              >
                <svg
                  className="stroke"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 1H15C15.5304 1 16.0391 1.21071 16.4142 1.58579C16.7893 1.96086 17 2.46957 17 3V4M17 14V15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H14M4 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V14M1 4V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H4M9 15V17M1 9H3M9 1V3M17 9H15M6 9C6 9.79565 6.31607 10.5587 6.87868 11.1213C7.44129 11.6839 8.20435 12 9 12C9.79565 12 10.5587 11.6839 11.1213 11.1213C11.6839 10.5587 12 9.79565 12 9C12 8.20435 11.6839 7.44129 11.1213 6.87868C10.5587 6.31607 9.79565 6 9 6C8.20435 6 7.44129 6.31607 6.87868 6.87868C6.31607 7.44129 6 8.20435 6 9Z"
                    stroke="#667185"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div>IoT Devices</div>
              </div>
            )}
            {listOfNames.includes("settings") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/settings");
                window.scrollTo(0, 0);
              }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.2948 9.01453C11.6793 8.95374 11.06 9.08469 10.5218 9.38945C9.98353 9.69421 9.55266 10.1579 9.28813 10.717C9.02361 11.2761 8.93836 11.9033 9.04406 12.5127C9.14976 13.1221 9.44125 13.684 9.87861 14.1213C10.316 14.5587 10.8778 14.8502 11.4872 14.9559C12.0967 15.0616 12.7239 14.9763 13.283 14.7118C13.8421 14.4473 14.3057 14.0164 14.6105 13.4782C14.9152 12.94 15.0462 12.3207 14.9854 11.7052C14.9161 11.0151 14.6104 10.3703 14.12 9.87995C13.6296 9.38958 12.9848 9.08384 12.2948 9.01453ZM19.5182 12C19.5163 12.3261 19.4923 12.6517 19.4465 12.9745L21.5657 14.6367C21.658 14.7132 21.7202 14.8199 21.7412 14.9379C21.7622 15.056 21.7407 15.1776 21.6806 15.2812L19.6757 18.75C19.6148 18.8527 19.5197 18.9305 19.407 18.9699C19.2943 19.0093 19.1713 19.0076 19.0598 18.9652L16.9551 18.1177C16.839 18.0714 16.7133 18.0547 16.5892 18.0691C16.4651 18.0834 16.3465 18.1283 16.244 18.1997C15.9228 18.4209 15.5853 18.6174 15.2343 18.7875C15.124 18.8411 15.0285 18.9211 14.9564 19.0203C14.8843 19.1196 14.8378 19.2351 14.8209 19.3566L14.5054 21.6014C14.4847 21.72 14.4234 21.8276 14.3321 21.906C14.2408 21.9844 14.1251 22.0287 14.0048 22.0312H9.99509C9.87675 22.0292 9.76264 21.9869 9.67155 21.9113C9.58047 21.8357 9.51784 21.7314 9.494 21.6155L9.179 19.3739C9.16131 19.2511 9.11354 19.1345 9.03994 19.0346C8.96634 18.9346 8.86919 18.8544 8.75712 18.8011C8.4066 18.6319 8.07021 18.4349 7.75118 18.2119C7.64904 18.1408 7.53082 18.0963 7.40717 18.0823C7.28353 18.0683 7.15835 18.0853 7.0429 18.1317L4.93868 18.9788C4.82717 19.0212 4.70425 19.023 4.59158 18.9837C4.4789 18.9444 4.3837 18.8666 4.32275 18.7641L2.3179 15.2953C2.25763 15.1917 2.23609 15.07 2.25712 14.952C2.27815 14.834 2.34039 14.7272 2.43275 14.6508L4.22384 13.2445C4.32197 13.1666 4.39909 13.0655 4.4482 12.9502C4.49732 12.835 4.51687 12.7093 4.50509 12.5845C4.48822 12.3891 4.4779 12.1941 4.4779 11.9986C4.4779 11.8031 4.48775 11.6109 4.50509 11.4197C4.51558 11.2957 4.49507 11.1711 4.4454 11.057C4.39573 10.9429 4.31846 10.843 4.22056 10.7662L2.4304 9.36C2.33954 9.28317 2.27862 9.17681 2.2583 9.05957C2.23799 8.94232 2.25959 8.82167 2.31931 8.71875L4.32415 5.25C4.38504 5.14734 4.48021 5.06946 4.59289 5.0301C4.70557 4.99074 4.82853 4.99242 4.94009 5.03484L7.04478 5.88234C7.16084 5.92856 7.28656 5.94525 7.41066 5.93094C7.53476 5.91662 7.65338 5.87174 7.75587 5.80031C8.07708 5.57912 8.41461 5.38262 8.76556 5.2125C8.87589 5.15887 8.97132 5.07891 9.04343 4.97966C9.11553 4.88042 9.16209 4.76494 9.179 4.64344L9.49447 2.39859C9.51519 2.28004 9.57644 2.17236 9.66775 2.09396C9.75906 2.01555 9.87476 1.9713 9.99509 1.96875H14.0048C14.1231 1.9708 14.2372 2.01309 14.3283 2.08867C14.4194 2.16425 14.482 2.2686 14.5059 2.38453L14.8209 4.62609C14.8386 4.74894 14.8863 4.86551 14.9599 4.96544C15.0335 5.06537 15.1307 5.14557 15.2427 5.19891C15.5933 5.3681 15.9297 5.56514 16.2487 5.78813C16.3508 5.85919 16.469 5.90373 16.5927 5.91772C16.7163 5.93172 16.8415 5.91473 16.957 5.86828L19.0612 5.02125C19.1727 4.97879 19.2956 4.97704 19.4083 5.01631C19.521 5.05558 19.6162 5.13336 19.6771 5.23594L21.682 8.70469C21.7422 8.80832 21.7638 8.92999 21.7428 9.04802C21.7217 9.16604 21.6595 9.27278 21.5671 9.34922L19.776 10.7555C19.6775 10.8331 19.5999 10.9342 19.5504 11.0494C19.5008 11.1647 19.4809 11.2905 19.4924 11.4155C19.5079 11.6095 19.5182 11.8045 19.5182 12Z"
                    stroke="#667185"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div>Settings</div>
              </div>
            )}
            {listOfNames.includes("resources") && (
              <div className="search-list__flex"
              onClick={() => {
                navigate("/user/resources");
                window.scrollTo(0, 0);
              }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.5 10.25L21 12.5L12 17L3 12.5L7.5 10.25M16.5 15.25L21 17.5L12 22L3 17.5L7.5 15.25M12 3L21 7.5L12 12L3 7.5L12 3Z"
                    stroke="#667185"
                    stroke-width="2"
                  />
                </svg>

                <div>Resources</div>
              </div>
            )}
          </div>
          }
        </form>
      </div>
      <div className="search_flex">
        <div className="notification pointer" onClick={handleModalOpen}>
         {notifications1?.length > 0 || notifications2?.length > 0 ? <svg
            className="badge"
            width="7"
            height="6"
            viewBox="0 0 7 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.5 6C5.15685 6 6.5 4.65685 6.5 3C6.5 1.34315 5.15685 0 3.5 0C1.84315 0 0.5 1.34315 0.5 3C0.5 4.65685 1.84315 6 3.5 6Z"
              fill="#D42620"
            />
          </svg> : ""}
         {notifications1?.length < 1 && notifications2?.length < 1 ?
          <svg className="badge" width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3.5 6C5.15685 6 6.5 4.65685 6.5 3C6.5 1.34315 5.15685 0 3.5 0C1.84315 0 0.5 1.34315 0.5 3C0.5 4.65685 1.84315 6 3.5 6Z" fill="#667185"/>
          </svg>
           : ""}



          <svg
            width="20"
            height="23"
            viewBox="0 0 20 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.5 12.4395V10.5H16V12.75C16 12.9489 16.0791 13.1396 16.2197 13.2803L18.25 15.3105V16.5H1.75V15.3105L3.78025 13.2803C3.92091 13.1396 3.99996 12.9489 4 12.75V9.75C3.99791 8.6961 4.27398 7.6603 4.80032 6.74724C5.32665 5.83417 6.08463 5.07618 6.99767 4.5498C7.91072 4.02343 8.9465 3.74733 10.0004 3.74938C11.0543 3.75144 12.089 4.03157 13 4.5615V2.88525C12.2861 2.56914 11.5267 2.36766 10.75 2.28825V0.75H9.25V2.2875C7.40093 2.4757 5.68732 3.34284 4.44053 4.72124C3.19373 6.09964 2.50233 7.89138 2.5 9.75V12.4395L0.46975 14.4697C0.329088 14.6104 0.250042 14.8011 0.25 15V17.25C0.25 17.4489 0.329018 17.6397 0.46967 17.7803C0.610322 17.921 0.801088 18 1 18H6.25V18.75C6.25 19.7446 6.64509 20.6984 7.34835 21.4016C8.05161 22.1049 9.00544 22.5 10 22.5C10.9946 22.5 11.9484 22.1049 12.6517 21.4016C13.3549 20.6984 13.75 19.7446 13.75 18.75V18H19C19.1989 18 19.3897 17.921 19.5303 17.7803C19.671 17.6397 19.75 17.4489 19.75 17.25V15C19.75 14.8011 19.6709 14.6104 19.5303 14.4697L17.5 12.4395ZM12.25 18.75C12.25 19.3467 12.0129 19.919 11.591 20.341C11.169 20.7629 10.5967 21 10 21C9.40326 21 8.83097 20.7629 8.40901 20.341C7.98705 19.919 7.75 19.3467 7.75 18.75V18H12.25V18.75Z"
              fill="#667185"
            />
          </svg>
        </div>
        <div
          className="profile"
          onClick={() => {
            navigate("/profile");
            window.scrollTo(0, 0);
          }}
        >
          <div className="search_name">
            {firstName?.split("")[0]}
            {lastName?.split("")[0]}
            <svg
              className="kyc_svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.0758 2.14075C13.31 2.14075 13.5 1.935 13.5 1.68225V0.95825C13.5 0.705 13.31 0.5 13.0758 0.5H2.92425C2.68975 0.5 2.5 0.705 2.5 0.95825V1.68225C2.5 1.935 2.68975 2.1405 2.92425 2.1405H3.1875V13.8593H2.92425C2.68975 13.8593 2.5 14.0642 2.5 14.3175V15.0413C2.5 15.2945 2.68975 15.5 2.92425 15.5H13.0755C13.31 15.5 13.5 15.2945 13.5 15.0413V14.3175C13.5 14.0642 13.31 13.8593 13.0758 13.8593H12.8125V2.14075H13.0758ZM3.64575 13.8595V2.14075H4.07675C3.9655 2.14075 3.875 2.2245 3.875 2.328V2.8905C3.875 2.994 3.9645 3.07725 4.0755 3.078C4.0755 5.15025 4.4075 7.16425 6.8085 7.85825L6.927 7.89575C7.03075 7.92875 7.155 7.96775 7.2185 8C7.155 8.03175 7.03225 8.07075 6.929 8.10325L6.81575 8.1395C4.40775 8.836 4.07575 10.8498 4.07575 12.922C3.965 12.9227 3.87525 13.0063 3.87525 13.1093V13.6718C3.87525 13.7753 3.9655 13.8595 4.077 13.8595H3.64575ZM8.9365 8.55125L9.06 8.59025C10.7615 9.08225 11.4257 10.2015 11.4642 12.6875H8.204C8.17125 11.5315 8.08925 8.57925 8.08925 8C8.08925 7.80375 8.45225 7.5285 8.61925 7.43025C9.324 7.014 10.2305 6.1905 10.2305 5.3335H5.769C5.769 6.1905 6.6755 7.014 7.38025 7.43025C7.54675 7.52875 7.91025 7.80375 7.91025 8C7.91025 8.5945 7.8285 11.5345 7.79575 12.6875H4.53575C4.574 10.2022 5.239 9.0825 6.947 8.58825L7.06425 8.5515C7.3925 8.448 7.7025 8.35 7.7025 8.00025C7.7025 7.65 7.3915 7.55175 7.06175 7.44825L6.93975 7.4095C5.2385 6.9175 4.57425 5.7985 4.536 3.31275H11.4648C11.4263 5.7985 10.7615 6.91825 9.054 7.41175L8.93975 7.448C8.60975 7.5515 8.298 7.64975 8.298 8.00025C8.2975 8.34975 8.608 8.44775 8.9365 8.55125ZM12.354 13.8595H11.9235C12.0345 13.8595 12.125 13.7753 12.125 13.6718V13.1093C12.125 13.006 12.035 12.9227 11.9242 12.9222C11.9242 10.8497 11.5922 8.8355 9.19125 8.1415L9.07125 8.1035C8.96825 8.071 8.845 8.032 8.7815 8.00025C8.84525 7.968 8.96975 7.929 9.07375 7.896L9.1845 7.86075C11.5922 7.16475 11.9242 5.15075 11.9242 3.07825C12.0347 3.07775 12.125 2.99425 12.125 2.8905V2.328C12.125 2.2245 12.0347 2.14075 11.9235 2.14075H12.354V13.8595Z"
                fill={
                  kycStatus === "pending"
                    ? "#00AED9"
                    : kycStatus === "completed"
                    ? "#0F973D"
                    : ""
                }
              />
            </svg>
            {kycStatus === "pending" ? (
              <div className="tag tag_progress">
                KYC Validation <br /> confirmation in progress
              </div>
            ) : kycStatus === "completed" ? (
              <div className="tag">
                KYC Validation <br /> confirmation completed
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="profile_title">Profile</div>
        </div>
      </div>

      {modalOpen && <Notifications handleModalClose={handleModalClose} />}
      {searchModalOpen &&  <div className="search-list-modal" onClick={handleSearchModalClose}></div>}

    </div>
  );
};

export default Search;
